<app-loader></app-loader>

<div class="layout-container" [ngClass]="containerClass">
   <app-sidebar></app-sidebar>
   <div class="layout-content-wrapper">
      <app-topbar></app-topbar>
      <div class="layout-content">
         <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
         <router-outlet></router-outlet>
      </div>
   </div>
   <app-profilemenu></app-profilemenu>
   <p-scrollTop [threshold]="500"></p-scrollTop>
   <elevenlabs-convai
      #elevenLabsWidget
      *ngIf="isSuperAdmin"
      id="elevenlabs-widget"
      class="elevenlabs-widget"
      [class.elevenlabs-widget--hidden]="!(elevenLabsWidgetService.visible$ | async)"
      agent-id="agent_0201kqxxammqfrqa9x9vbsxk95cm"
      variant="expanded"
      default-expanded="true"
      always-expanded="true"
      dismissible="false"
   ></elevenlabs-convai>
</div>

<app-announcement-banner></app-announcement-banner>
